import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { TranslateModule, TranslateService } from 'ng2-translate/ng2-translate';


@Component({
  selector: 'text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.css']
})

export class TextEditorComponent {

  @Input() disabled: Boolean;
  @Input() group: FormGroup;
  @Input() content: String;
  @Input() labelType: String;

  ckOptions: any;

  constructor(
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/text-editor/text-editor.component.ts